export default __webpack_public_path__ + "img/hk_mixer-29b4f31ce8c98f717bdbec2bf4c3e49a.png";